import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type TrelloUpdateCheckItemStateOnCardActionFieldsFragment = (
  { __typename: 'TrelloUpdateCheckItemStateOnCardAction' }
  & Pick<Types.TrelloUpdateCheckItemStateOnCardAction, 'id' | 'date' | 'displayKey' | 'type'>
  & { displayEntities?: Types.Maybe<(
    { __typename: 'TrelloUpdateCheckItemStateOnCardActionDisplayEntities' }
    & { card?: Types.Maybe<(
      { __typename: 'TrelloActionCardEntity' }
      & Pick<Types.TrelloActionCardEntity, 'objectId' | 'shortLink' | 'text' | 'type'>
    )>, checkItem?: Types.Maybe<(
      { __typename: 'TrelloActionCheckItemEntity' }
      & Pick<Types.TrelloActionCheckItemEntity, 'text' | 'type'>
    )>, memberCreator?: Types.Maybe<(
      { __typename: 'TrelloActionMemberEntity' }
      & Pick<Types.TrelloActionMemberEntity, 'text' | 'type'>
    )> }
  )>, appCreator?: Types.Maybe<(
    { __typename: 'TrelloAppCreator' }
    & Pick<Types.TrelloAppCreator, 'id' | 'name'>
  )>, creator?: Types.Maybe<(
    { __typename: 'TrelloMember' }
    & Pick<Types.TrelloMember, 'id'>
  )> }
);

export const TrelloUpdateCheckItemStateOnCardActionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'TrelloUpdateCheckItemStateOnCardActionFields',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloUpdateCheckItemStateOnCardAction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'displayEntities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'card' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TrelloActionCardEntityFields',
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'checkItem' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'memberCreator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: {
                          kind: 'Name',
                          value: 'TrelloActionMemberEntityFields',
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'FragmentSpread',
            name: { kind: 'Name', value: 'TrelloCoreActionFields' },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloActionCardEntityFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloActionCardEntity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'objectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'shortLink' } },
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloActionMemberEntityFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloActionMemberEntity' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'text' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'TrelloCoreActionFields' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'TrelloAction' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'appCreator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'creator' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayKey' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseTrelloUpdateCheckItemStateOnCardActionFieldsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      TrelloUpdateCheckItemStateOnCardActionFieldsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseTrelloUpdateCheckItemStateOnCardActionFieldsFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<TrelloUpdateCheckItemStateOnCardActionFieldsFragment>,
    'data'
  > {
  data?: TrelloUpdateCheckItemStateOnCardActionFieldsFragment;
}

export const useTrelloUpdateCheckItemStateOnCardActionFieldsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseTrelloUpdateCheckItemStateOnCardActionFieldsFragmentOptions): UseTrelloUpdateCheckItemStateOnCardActionFieldsFragmentResult => {
  const result =
    Apollo.useFragment<TrelloUpdateCheckItemStateOnCardActionFieldsFragment>({
      ...options,
      fragment: TrelloUpdateCheckItemStateOnCardActionFieldsFragmentDoc,
      fragmentName: 'TrelloUpdateCheckItemStateOnCardActionFields',
      from: {
        __typename: 'TrelloUpdateCheckItemStateOnCardAction',
        ...from,
      },
    });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return {
    ...result,
    data: result.data as TrelloUpdateCheckItemStateOnCardActionFieldsFragment,
  };
};
